const getBearToken = () => {
    const BToken = localStorage.getItem("veeperAuthToken");
    return JSON.parse(BToken);
}

/**
 * Decodes the JWT payload and returns the expiry timestamp in ms.
 * Returns null if the token is missing or malformed.
 */
export const getTokenExpiry = (rawToken) => {
    try {
        const token = rawToken.replace(/^Bearer\s+/i, "")
        const base64Url = token.split(".")[1]
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/")
        const payload = JSON.parse(atob(base64))
        return typeof payload.exp === "number" ? payload.exp * 1000 : null
    } catch {
        return null
    }
}

/**
 * Returns true if the stored token is missing or past its expiry time.
 */
export const isTokenExpired = () => {
    const raw = localStorage.getItem("veeperAuthToken")
    if (!raw) return true
    const token = JSON.parse(raw)
    const expiry = getTokenExpiry(token)
    if (expiry === null) return false // non-expiring token — treat as valid
    return Date.now() >= expiry
}

export default getBearToken;